

import ReducerGestaoProdutos from './gerenciaProdutoReducer';

const reducers = {
    reducer: {
        gestaoProdutoReducer: ReducerGestaoProdutos
    }
}

export {reducers};